import React, { Component } from 'react';
import RiskAssessmentContent from './RiskAssessmentContent';
import { RuleCategory } from '../../../../services/RuleCategory';

// RuleCategory.ANTI_MONEY_LAUNDERING
class AntiMoneyLaunderingMW extends Component {
    render() {
        return (
            <RiskAssessmentContent
                ruleCategory={RuleCategory.ANTI_MONEY_LAUNDERING}
            />
        );
    }
}

export default AntiMoneyLaunderingMW;
